import { Socket } from '../utils/socket'
import { CopyBase, TRANSFER_EVENT_COMPLETE, TRANSFER_EVENT_FAILED, TRANSFER_EVENT_PROGRESS, TRANSFER_EVENT_START } from './copy-base'

export class NodeCopy extends CopyBase {
  constructor(id, type, name, server, endpoint, gotoPath) {
    super(id, type, name, gotoPath)

    this._socket = new Socket(server, endpoint, this.handleOpen, this.handleMessage, this.handleClose, this.handleError)

    this._msgData = null
  }

  get msgData() {
    return this._msgData
  }

  get progress() {
    return this._msgData ? this._msgData.progress : 0
  }

  get queued() {
    return this._msgData ? this._msgData.queued : false
  }

  cleanup() {
    this._socket = null
  }

  async start(data) {
    await this._socket.connectAsync(this)
    this._socket.send(data)
    this.dispatchEvent(TRANSFER_EVENT_START)
  }

  cancel() {}

  handleOpen() {}

  handleMessage(msgData) {
    this._msgData = msgData

    if (msgData.complete) {
      this.notifySet()
      this.dispatchEvent(TRANSFER_EVENT_COMPLETE)
      this._socket.close()
      return
    }

    this.dispatchEvent(TRANSFER_EVENT_PROGRESS)
  }

  // The server closes the socket after its last message; closed (or broken)
  // before a complete one, the copy didn't finish (content records why and
  // rolls the copy back, but sends no message). Until 2026-10-19 this left
  // the copy "running" for good: the tray and the copy page never said.
  handleClose() {
    this.failUnlessDone()
    this.cleanup()
  }

  handleError() {
    this.failUnlessDone()
    this.cleanup()
  }

  failUnlessDone() {
    if (this.status === TRANSFER_EVENT_COMPLETE || this.status === TRANSFER_EVENT_FAILED) return
    this.dispatchEvent(TRANSFER_EVENT_FAILED)
  }
}
